module.exports = __webpack_public_path__ + "static/media/mould2.1de38f1e.jpg";